export * from './post-erforderliches-dokument-request.interface';
export * from './post-erforderliches-dokument-response.interface';
export * from './post-erforderliches-dokument.shapes';
